import "../Admin.css";
import { useNavigate } from "react-router-dom";
import Admin from "../Admin";

export default function AdminPage() {
  const navigate = useNavigate();
  return <Admin onGoHome={() => navigate('/')} />;
}